import { addDays, differenceInYears, set } from 'date-fns';

export const getAge = (birthday: Date, origin = new Date()): number => {
  // 参考 https://ja.wikipedia.org/wiki/%E5%B9%B4%E9%BD%A2%E8%A8%88%E7%AE%97%E3%83%8B%E9%96%A2%E3%82%B9%E3%83%AB%E6%B3%95%E5%BE%8B#%E5%B9%B4%E9%BD%A2%E3%81%AE%E8%A8%88%E7%AE%97%E6%96%B9%E6%B3%95
  const countUpAgeTime = set(addDays(birthday, -1), {
    hours: 24,
    minutes: 0,
    seconds: 0,
  });
  return differenceInYears(origin, countUpAgeTime);
};

export const getAgeGroup = (birthday: Date, origin = new Date()): number =>
  Math.floor(getAge(birthday, origin) / 10) * 10;
